/**
 * This is a cross-platform way to determine if the product is (or is not) Daylight
 *
 * IDEA: Remove this function
 * WHEN: When content for MFA comes from the BE, this will no longer be needed
 */
export const isDaylight = (): boolean => false;
